<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>Add New Widget</h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div class="widgets">
    <div class="widget" mat-ripple (click)="openWidgetDialog(widget.component)" *ngFor="let widget of widgets">
      <img [src]="settings.getAssetUrl('images/widgets/' + widget.image)" class="widget-img" alt="">
      <div class="name" trans>{{widget.name || widget.type}}</div>
      <div class="description" trans>{{widget.description}}</div>
    </div>
  </div>
</div>
